export default {
  data: function() {
    return {
      valid: true,
      user_ids: []
    };
  },
  methods: {
    transferUserId: function() {
      var first = this.user_ids[0];
      if (first && typeof first === 'object') {
        return first.id || null;
      }
      return first || null;
    },
    markTransferValid: function() {
      if (this.valid) {
        return;
      }
      this.valid = true;
    },
    getData: function() {
      var data = this.transferUserId();
      if (!data) {
        this.valid = false;
        if (typeof this.onTransferInvalid === 'function') {
          this.onTransferInvalid();
        }
        return;
      }
      return data;
    }
  }
};
